import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=773b27a7&scoped=true&"
import script from "./NotFound.js?vue&type=script&lang=js&"
export * from "./NotFound.js?vue&type=script&lang=js&"
import style0 from "./NotFound.scss?vue&type=style&index=0&id=773b27a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773b27a7",
  null
  
)

export default component.exports